<page-wrap  [headline]="course?.course?.title ?? 'Промяна на страница'"
            [navigation]="[{
                title: (user | roleAny:'admin') ? ('Партньори' | transloco) : ('Закупени курсове' | transloco),
                link: (user | roleAny:'admin') ? '/partners' : '/courses'
            },{
                title: (user | roleAny:'admin') ? (franchise?.name ?? '') : (course?.course?.title ?? ''),
                link: (user | roleAny:'admin') ? ('/partners/' + franchiseId) : ('/courses/' + courseId)
            },{
                title: ('Редакция на страница на курс' | transloco),
                link: '/partners/' + franchiseId + '/courses/' + courseId + '/edit'
            },]"
>

    <ng-template section="sidebar"></ng-template>

    <ng-container>

        <form class="standard-form d-flex flex-column" [formGroup]="form" (submit)="onSubmit($event)" *ngIf="form">

            <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h2>
                        {{'Курс' | transloco}}
                    </h2>
                    <div class="form-check form-switch d-inline-block">
                        <input class="form-check-input" type="checkbox" id="statusToggle" formControlName="status">
                        <label class="form-check-label" for="statusToggle">{{ this.form?.get('status')?.value ? ('Активен'|transloco) : ('Неактивен'|transloco) }}</label>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3 row">
                                <label for="url" class="col-12">{{ 'URL:' | transloco }}</label>
                                <div class="col-12">
                                    <input  requiredField requiredFieldAttribute="url"
                                            type="text"
                                            id="url"
                                            class="form-control"
                                            name="url"
                                            [placeholder]="'Кратък (уникален) адрес' | transloco "
                                            formControlName="url"
                                            [attr.disabled]="loading ? true : null"
                                            [class.is-invalid]="errors?.url?.status === 'INVALID'"
                                    />
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.notunique">{{ 'Полето не съдържа уникален адрес' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.any">{{ errors?.url?.errors?.any }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="user && (user | roleAny:'admin')">
                        <label for="design" class="col-12">{{ 'Дизайн:' | transloco }}</label>
                        <div class="col-12">
                            <p-dropdown inputId="design"
                                        [class.is-invalid]="errors?.design?.status === 'INVALID'"
                                        [filter]="false"
                                        [options]="designOptions"
                                        formControlName="design"
                                        optionValue="id"
                                        optionLabel="title"
                                        styleClass="w-100"
                            ></p-dropdown>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Card 1: List and Select Sections -->
            <div class="card d-flex mt-5">
              <div class="card-header d-flex justify-content-between align-items-center">
                <h2>{{'Секции' | transloco}}</h2>
                <button type="button" class="btn btn-primary" (click)="addSection()">
                  <i class="fa-solid fa-plus fa-fw"></i> {{'Добави' | transloco}}
                </button>
              </div>
              <div class="card-body" formArrayName="sections">
                <div cdkDropList class="section-list" (cdkDropListDropped)="drop($event)">
                    <div    *ngFor="let section of sectionControls.controls; let i = index"
                            class="section-select d-flex justify-content-between align-items-center"
                            cdkDrag
                            (click)="selectSection(i)"
                            [ngClass]="{'selected-section': i === selectedSectionIndex}"
                            >
                        <h2 class="m-0">
                            {{ getSectionTitleDisplay(section.get('type')?.value ?? 'Секция', i) }}
                        </h2>
                        <span class="py-0 px-2 me-3" (click)="removeSection(i)"><i class="fa-solid fa-fw fa-trash text-danger"></i></span>
                    </div>
                </div>
              </div>
            </div>

            <!-- Card 2: Fields of the Selected Section -->
            <div *ngIf="form.get('selectedSection') && selectedSectionIndex !== null" class="card mt-5" [formGroup]="selectedSectionFormGroup">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h2>{{ ('Детайли на секция' | transloco) }}</h2>
                    <div class="form-check form-switch d-inline-block">
                        <input class="form-check-input" type="checkbox" id="sectionStatusToggle{{ selectedSectionIndex }}" formControlName="status">
                        <label class="form-check-label" for="sectionStatusToggle{{ selectedSectionIndex }}">{{ selectedSectionFormGroup.get('status')?.value ? ('Активен'|transloco) : ('Неактивен'|transloco) }}</label>
                    </div>
                </div>
                <div class="card-body" >
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group d-flex flex-column">
                                <label for="type">{{ 'Тип' | transloco }}</label>
                                <p-dropdown [options]="sectionTypeOptions"
                                            optionLabel="label"
                                            optionValue="value"
                                            formControlName="type"
                                            styleClass="w-100">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="col-lg-6" *ngIf="currentAllowedFieldsStatus['title']">
                            <div class="form-group d-flex flex-column">
                                <label for="title">{{ 'Заглавие' | transloco }}</label>
                                <input
                                        type="text"
                                        class="form-control"
                                        formControlName="title"
                                        [class.is-invalid]="selectedSectionFormGroup?.controls?.['title']?.status === 'INVALID'">

                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['title']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6" *ngIf="currentAllowedFieldsStatus['subtitle']">
                            <div class="form-group d-flex flex-column">
                                <label for="subtitle">{{ 'Подзаглавие' | transloco }}</label>
                                <input  type="text"
                                        class="form-control"
                                        formControlName="subtitle"
                                        [class.is-invalid]="selectedSectionFormGroup?.controls?.['subtitle']?.status === 'INVALID'">
                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['subtitle']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                            </div>
                        </div>
                        <div class="col-lg-6" *ngIf="currentAllowedFieldsStatus['alt']">
                            <div class="form-group d-flex flex-column">
                                <label for="alt">{{ 'Алтернативен текст' | transloco }}</label>
                                <input  type="text"
                                        class="form-control"
                                        formControlName="alt"
                                        [class.is-invalid]="selectedSectionFormGroup?.controls?.['alt']?.status === 'INVALID'">
                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['alt']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="currentAllowedFieldsStatus['description']">
                        <div class="form-group d-flex flex-column py-3">
                            <label for="itemDescription" class="col-12">{{ 'Съдържание:' | transloco }}</label>
                            <div class="col-12">
                                <text-editor    type="text"
                                                id="itemDescription"
                                                name="description"
                                                formControlName="description"
                                                [attr.disabled]="loading ? true : null"
                                                [class.is-invalid]="selectedSectionFormGroup?.controls?.['description']?.status === 'INVALID'"
                                ></text-editor>
                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['description']?.errors?.['maxlength']">{{ 'Не може да е повече от 1000 символа' | transloco:{length: 1000} }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="currentAllowedFieldsStatus['image']">
                        <div class="col-lg-6">
                            <div class="form-group d-flex flex-column">
                                <label>{{ 'Снимка' | transloco }}</label>
                                <upload-image   (onFinished)="onFileFinished($event, false, selectedSectionIndex)"
                                                (onRemove)="removeFile(false, selectedSectionIndex)"
                                                [preview]="getPhotoUrl(false, selectedSectionIndex)"
                                                [withRemove]="true"
                                                [loading]="loading"
                                                [class.is-invalid]="selectedSectionFormGroup?.controls?.['image']?.status === 'INVALID'">
                                </upload-image>
                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['image']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 1000} }}</div>
                            </div>
                        </div>
                        <!--    Thumbnail of section
                                <div class="col-lg-6">
                            <div class="form-group d-flex flex-column">
                                <label>{{ 'Тъмбнейл' | transloco }}</label>
                                <upload-image   (onFinished)="onFileFinished($event, true, selectedSectionIndex)"
                                                (onRemove)="removeFile(true, selectedSectionIndex)"
                                                [preview]="getPhotoUrl(true, selectedSectionIndex)"
                                                [loading]="loading"
                                                [class.is-invalid]="selectedSectionFormGroup?.controls?.['thumbnail']?.status === 'INVALID'">
                                </upload-image>
                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['thumbnail']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                            </div>
                        </div> -->
                    </div>

                </div>
            </div>

            <!-- Card 3: Items of the Selected Section -->
            <div *ngIf="selectedSectionIndex !== null" class="card mt-5">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h2>{{('Елементи на Секция' | transloco) }}</h2>
                    <button type="button" class="btn btn-primary" (click)="addItem()" *ngIf="canAddItems">
                        <i class="fa-solid fa-plus fa-fw"></i> {{'Добави' | transloco}}
                    </button>
                </div>
                <div class="card-body p-0">
                    <div class="alert alert-warning" *ngIf="!canAddItems">
                        <p class="mb-0">{{'Към този тип секция не могат да бъдат добавени елементи.' | transloco}}</p>
                    </div>
                    <div cdkDropList class="accordion accordion-flush" id="accordionFlushExample" (cdkDropListDropped)="dropItem($event)">
                        <div *ngFor="let item of selectedSectionItems.controls; let j = index" cdkDrag class="accordion-item" [formGroup]="getFormGroupAtIndex(j)">
                            <h2 class="accordion-header d-flex justify-content-between" [id]="'heading' + j">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + j" aria-expanded="true" [attr.aria-controls]="'collapse' + j">
                                    {{ ('Елемент' | transloco) + ' ' + (j + 1) }}
                                </button>
                                <div class="d-flex align-items-center">
                                    <div class="form-check form-switch fs-6 pt-3 me-4">
                                        <input class="form-check-input mt-2" type="checkbox" [id]="'itemStatusToggle' + j" formControlName="status" [checked]="item.get('status')?.value">
                                        <label class="form-check-label" [for]="'itemStatusToggle' + j">
                                            {{ item.get('status')?.value ? ('Активен' | transloco) : ('Неактивен' | transloco) }}
                                        </label>
                                    </div>
                                    <span class="py-0 px-2 mt-3 me-3" (click)="removeItem(j)"><i class="fa-solid fa-fw fa-trash text-danger"></i></span>
                                </div>
                            </h2>
                            <div [id]="'collapse' + j" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading' + j" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div class="row">
                                        <div class="col-lg-6" *ngIf="currentAllowedItemsStatus['title']">
                                            <div class="form-group">
                                                <label>{{'Заглавие' | transloco}}</label>
                                                <input  type="text"
                                                        class="form-control"
                                                        formControlName="title"
                                                        [class.is-invalid]="item?.get('title')?.status === 'INVALID'">
                                                <div class="invalid-feedback" *ngIf="item?.get('title')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6" *ngIf="currentAllowedItemsStatus['subtitle']">
                                            <div class="form-group">
                                                <label>{{'Подзаглавие' | transloco}}</label>
                                                <input type="text" class="form-control" formControlName="subtitle" [class.is-invalid]="item?.get('subtitle')?.status === 'INVALID'">
                                                <div class="invalid-feedback" *ngIf="item?.get('subtitle')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6" *ngIf="currentAllowedItemsStatus['alt']">
                                            <div class="form-group">
                                                <label>{{'Алтернативен текст' | transloco}}</label>
                                                <input type="text" class="form-control" formControlName="alt" [class.is-invalid]="item?.get('alt')?.status === 'INVALID'">
                                                <div class="invalid-feedback" *ngIf="item?.get('alt')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="currentAllowedItemsStatus['description']">
                                        <div class="form-group d-flex flex-column py-3">
                                            <label for="description" class="col-12">{{ 'Съдържание:' | transloco }}</label>
                                            <div class="col-12">
                                                <text-editor    type="text"
                                                                id="description"
                                                                name="description"
                                                                formControlName="description"
                                                                [attr.disabled]="loading ? true : null"
                                                                [class.is-invalid]="item?.get('description')?.status === 'INVALID'"
                                                ></text-editor>
                                                <div class="invalid-feedback" *ngIf="item?.get('description')?.errors?.['maxlength']">{{ 'Не може да е повече от 1000 символа' | transloco:{length: 1000} }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="currentAllowedItemsStatus['image']">
                                        <div class="col-lg-6">
                                            <div class="form-group d-flex flex-column">
                                                <label>{{ 'Снимка' | transloco }}</label>
                                                <upload-image   (onFinished)="onFileFinished($event, false, selectedSectionIndex, j)"
                                                                (onRemove)="removeFile(false, selectedSectionIndex, j)"
                                                                [preview]="getPhotoUrl(false, selectedSectionIndex, j)"
                                                                [loading]="loading"
                                                                [class.is-invalid]="item?.get('image')?.status === 'INVALID'">
                                                </upload-image>
                                                <div class="invalid-feedback" *ngIf="item?.get('image')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                                            </div>
                                        </div>
                                        <!--    Thumbnail of Item
                                                <div class="col-lg-6">
                                            <div class="form-group d-flex flex-column">
                                                <label>{{ 'Тъмбнейл' | transloco }}</label>
                                                <upload-image   (onFinished)="onFileFinished($event, true, selectedSectionIndex, j)"
                                                                (onRemove)="removeFile(true, selectedSectionIndex, j)"
                                                                [preview]="getPhotoUrl(true, selectedSectionIndex, j)"
                                                                [loading]="loading"
                                                                [class.is-invalid]="item?.get('thumbnail')?.status === 'INVALID'">
                                                </upload-image>
                                                 <div class="invalid-feedback" *ngIf="item?.get('thumbnail')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco:{length: 255} }}</div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="row my-5">
            <div class="col-12 text-center">
                    <button type="button"
                            class="btn btn-primary"
                            [disabled]="loading || (form?.get('payments')?.value?.length === 0)"
                            (click)="onSubmit($event)"
                    >
                        <i *ngIf="loading" class="fa-solid fa-spinner fa-fw fa-pulse"></i>
                        <i *ngIf="!loading" class="fa-solid fa-check fa-fw"></i>

                        <span class="mx-2">{{ 'Запиши' | transloco }}</span>
                    </button>
            </div>
        </div>
    </ng-container>

</page-wrap>
